/**
 * DOCUMENT READY SCRIPT
 */
$(function() {
    /**
     * Create new folder
     */
    $('#new-folder-popup').on('click', '.create-folder', function() {
        var form = $(this).closest('form');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                form.find('input, textarea').removeClass('error');
                form.find('label.error').text('');
                if (response.status == 'success') {

                    form.find('input[name=title], textarea[name=description]').val(null);

                    $('.dropdown.capsule-folders').each(function (dk, dropdown) {
                        dropdown = $(dropdown);
                        dropdown.find('ul').remove();
                        var move_to_dropdown = $('<ul></ul>').appendTo(dropdown.find('form'));
                        $.each(response.folders, function(k, v) {
                            var li = $('<li><a href="#" class="action"></a></li>');
                            li.find('a').text(v.title)
                                .attr('data-folder_id', v.id);
                            li.appendTo(move_to_dropdown);
                        });
                    });

                    var sort_dropdown = $('#folder-capsulations-dropdown');
                    sort_dropdown.find('.folder').remove();
                    var ul = sort_dropdown.find('ul');
                    $.each(response.folders, function(k, v) {
                        var li = $('<li class="folder"><a href="#" data-drop-point></a></li>');
                        li.find('a').text(v.title)
                            .attr('data-folder', v.id);
                        li.appendTo(ul);
                    });

                    $('.folders-list').empty().append($(response.html));

                    info(response.message);

                    hidePopup();
                }
                else {
                    $.each(response.errors, function(k, v) {
                        form.find('[name=' + k + ']').addClass('error')
                            .closest('.form-field')
                            .find('label.error').text(v);
                    });
                }
            },
            'json'
        );

        return false;
    });

    /**
     * Folder title/description edit
     */
    $('.folders-list').on('click', '[data-edit]', function() {
        var form = $($(this).data('edit'));

        var input = form.find('textarea');
        input.val($(this).data('value'));

        form.fadeIn(function() {
            input.autosize();
        });

        if ($(form).is(':visible')) {
            $(this).addClass('active');
        }
        else {
            $(this).removeClass('active');
        }

        return false;
    })
    .on('click', '.button-cancel', function() {
        var form = $(this).closest('form');
        var btn = $('.edit[data-edit="#' + form.attr('id') + '"]');

        $(btn).removeClass('active');
        form.fadeOut(function() {
            form.find('textarea').autosize();
        });

        return false;
    })
    .on('click', '.button-save', function() {
        var form = $(this).closest('form');
        var btn = $('.edit[data-edit="#' + form.attr('id') + '"]');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                if (response.status == 'success') {
                    $(btn).removeClass('active');
                    form.fadeOut(function() {
                        var folder = $(response.folder);
                        form.closest('article').replaceWith(folder);
                    });
                }
                else {
                    form.find('textarea').addClass('error');
                }

                info(response.message);
            },
            'json'
        );

        return false;
    });

    /**
     * Folder dropdown delete
     */
    $('body').on('click', '.button-settings.delete-folder', function() {
        if (!window.confirm($(this).data('confirm'))) {
            return false;
        }

        var form = $(this).closest('form');
        var folder = $('#folder-' + form.find('[name=id]').val());

        $.post(
            $(this).attr('href'),
            form.serialize(),
            function(response) {
                info(response.message);
                folder.remove();
            },
            'json'
        );

        return false;
    });
});